import React from "react";
import { Trans, useTranslation } from "react-i18next";

export function BillingPromoTermsMessage() {
    const { t } = useTranslation();

    return (
        <Trans
            t={t}
            i18nKey="By applying you agree to the <promoTermsLink>Promotion Terms and Conditions</promoTermsLink>"
            components={{ promoTermsLink: <a href="/promotion-terms" target="_blank" /> }}
        />
    );
}
